export const parentConstants = {
    menu: <menu[]>[

        {
            caption: 'Diary',
            icon: "dashboard_icon_diary.png",
            menuid: '1',
            menuKey: 'diary',
            children: [
                {
                    caption: 'Home work',
                    menuid: '1',
                    route: 'PDailyHomework',
                    path: '',
                    menuKey: '',
                    icon: "icon_homework.png",
                },
                {
                    caption: 'Assignment',
                    menuid: '3',
                    actionkey: '',
                    route: 'PAssignment',
                    menuKey: 'PAssignment',
                    path: '',
                    icon: "dashboard_icon_subjects.png",

                },
            ],
        },
        {
            caption: 'Online Session',
            icon: "icon_online_class.png",
            route: 'OnlineClass',
            menuKey: 'OnlineClass',
            menuid: '2',
            mnuicon: 'fa fa-desktop',
        },
        {
            caption: 'Online Assessment',
            icon: "fa fa-desktop",
            route: 'onlineassessment',
            menuKey: 'OnlineAssessment',
            menuid: '4',
            mnuicon: 'fa fa-desktop',
        },
        {
            caption: 'Fee Challan',
            icon: "dashboard_icon_fee_challans.png",
            route: 'feechallan',
            menuKey: 'feechallan',
            menuid: '3',
            mnuicon: 'fa fa-money',
        },
        {
            caption: 'Comm-unication',
            icon: "dashboard_icon_complaint.png",
            route: 'Communication',
            menuKey: 'Communication',
            menuid: '4',
            mnuicon: 'fa fa-desktop',
        },
        {
            caption: 'Attendance',
            icon: "dashboard_icon_attendance.png",
            route: 'StuAttendance',
            menuKey: 'StuAttendance',
            menuid: '5',
            mnuicon: 'fa fa-desktop',
        },
        {
            caption: 'Subject',
            icon: "dashboard_icon_subjects.png",
            route: 'Subject',
            menuKey: 'subject',
            menuid: '6',
            mnuicon: 'fa fa-desktop',
        },
        {
            caption: 'Time Table',
            icon: "dashboard_icon_time_table.png",
            route: 'TimeTable',
            menuKey: 'TimeTable',
            menuid: '7',
            mnuicon: 'fa fa-clock-o',
        },
        {
            caption: 'Assessment',
            icon: "dashboard_icon_assessment.png",
            route: 'assessment',
            menuKey: 'assessment',
            menuid: '7',
            mnuicon: 'fa fa-clock-o',
        },

        {
            caption: 'Class Work',
            icon: "dashboard_icon_class_work.png",
            route: 'classwork',
            menuKey: 'ClassWork',
            menuid: '7',
            mnuicon: 'fa fa-clock-o',
        },

        {
            caption: 'PTM',
            icon: "dashboard_icon_ptm_request.png",
            menuid: '7',
            menuKey: 'ptmrequest',
            children: [
                {
                    caption: 'Request',
                    menuid: '2',
                    actionkey: '',
                    controller: '',
                    route: 'Request',
                    menuKey: 'ptmrequest',
                    path: '',
                    icon: "dashboard_icon_subjects.png"
                },
                {
                }
            ],
        },



    ]
}


export class menu {
    route: string;
    caption: string;
    children: menu[];
    menuid: string;
    icon: string;
    menuKey: string;
    rights: any[] = ['create', 'update', 'view', 'delete'];
    disable: boolean = false;
    mnuicon: string;

}


// WEBPACK FOOTER //
// ./src/app/shell/sm/parent.contants.ts